/**
 * About page lead-in: the "Recapturing the American Dream" headline, centered in
 * brand red over the white page background. Sits beneath the fixed navbar, so it
 * carries top padding to clear it.
 */
export function AboutHeader() {
  return (
    <section className="w-full bg-withus-white px-6 pt-32 pb-12 md:px-12 md:pt-40 md:pb-16">
      <h1 className="withus-strong mx-auto max-w-[618px] text-center text-3xl leading-none text-withus-red md:text-5xl">
        Are you with us?
      </h1>
    </section>
  );
}
